import "./postReq.css";

import React from "react";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import ImageListItemBar from "@mui/material/ImageListItemBar";
import useMediaQuery from "@mui/material/useMediaQuery";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import { DestImgData, DestImgArr } from "../Constants.js";

const DestImgList = ({ handleDestSelect }) => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("md"));

  return (<>
    <Box sx={{mt: 1, mb: 1, textAlign:'center'}}>
      <Typography variant="body1" gutterBottom>
        Or Select from our Top Destinations
      </Typography>
    </Box>
    <ImageList
      gap={8}
      sx={
        !isMobile
          ? {
              margin: "0px auto",
              maxWidth: "60vw",
              textAlign: "center",
              gridTemplateColumns: "repeat(4, 2fr) !important",
            }
          : { widht: "100%" }
      }
    >
      {DestImgArr.map((item) => (
        <ImageListItem
          key={item.img}
          className="destinationCard"
          onClick={() => { 
            // if (item.value === "Others") {
            //   //redirect to generic form
            //   handleDestSelect();
            //   return;
            // }
            handleDestSelect({ target: { value: item.value } });
          }}
          style={!isMobile ? { alignItems: "center", fontWeight: 500 } : {}}
        >
          <img
            srcSet={`${item.img}?w=248&fit=crop&auto=format&dpr=2 2x`}
            src={`${item.img}?w=248&fit=crop&auto=format`}
            alt={item.title}
            loading="lazy"
            style={{
              height: "18vh",
              // maxWidth: !isMobile && "20vw",
              borderRadius: "8px 8px 4px 4px",
            }}
          />
          <ImageListItemBar title={item.title} position="below" />
        </ImageListItem>
      ))}
    </ImageList>
  </>);
};

export default DestImgList;
